export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10; // 10 seconds timeout for requests
export const RES_PER_PAGE = 10; // Number of results per page
export const API_KEY = '49db8224-ef58-4f8e-b1c8-fa08049fca1f'
export const MODAL_CLOSE_SEC = 2.5;
